// https://github.com/BrentonCozby/dom-slider
import { DEFAULT_TRANSITION_TIME } from '../config/main';

let styleCache = {};

export function slideDown(options) {
  return slide(options, 'down');
};

export function slideUp(options) {
  return slide(options, 'up');
};

export function initDomSlider() {
  init();
};

let init = function() {
  const sheet = document.createElement('style');
  sheet.id = 'dom-slider';
  sheet.innerHTML = `
    .DOM-slider-hidden {
      max-height: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      border-top-width: 0 !important;
      border-bottom-width: 0 !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(sheet);
};

let slide = function({element, slideSpeed = DEFAULT_TRANSITION_TIME, easing = 'linear', delay = 0, visibleDisplayValue = 'block'}, direction = null) {
  const domSliderId = element.dataset.domSliderId || (Date.now() * Math.random()).toFixed(0);

  if (!element.dataset.domSliderId) {
    element.dataset.domSliderId = domSliderId;
  }

  if (!styleCache[domSliderId]) {
    styleCache[domSliderId] = {};
  }

  const cachedStyle = styleCache[domSliderId];
  const computedStyle = window.getComputedStyle(element);
  const isDisplayNoneByDefault = computedStyle.getPropertyValue('display') === 'none';
  const slideDirection = direction || (isDisplayNoneByDefault || element.classList.contains('DOM-slider-hidden') ? 'down' : 'up');
  const speed = slideSpeed || ((slideSpeed === 0) ? 0 : 300);

  let paddingTop = parseInt(computedStyle.getPropertyValue('padding-top').split('px')[0], 10);
  let paddingBottom = parseInt(computedStyle.getPropertyValue('padding-bottom').split('px')[0], 10);
  let contentHeight = Math.max(element.scrollHeight - paddingTop - paddingBottom, 0);

  if (element.dataset.sliding) {
    return Promise.resolve(element);
  }

  if (slideDirection === 'down' && !isDisplayNoneByDefault && !element.classList.contains('DOM-slider-hidden')) {
    return Promise.resolve(element);
  }

  if (slideDirection === 'up' && element.classList.contains('DOM-slider-hidden')) {
    return Promise.resolve(element);
  }

  element.dataset.sliding = true;
  element.setAttribute('aria-hidden', slideDirection === 'down' ? 'false' : 'true');

  if (slideDirection === 'down' && isDisplayNoneByDefault) {
    element.classList.add('DOM-slider-hidden');
    element.style.display = visibleDisplayValue;
    contentHeight = element.scrollHeight;
  }

  // a fixed height is required in order to animate the height
  //element.style.height = `${cachedStyle.height ? cachedStyle.height : contentHeight}px`;
  element.style.maxHeight = `${cachedStyle.height ? cachedStyle.height : contentHeight}px`;
  element.style.transition = `all ${speed}ms ${easing || ''}`;
  element.style.overflow = 'hidden';

  return new Promise(function(resolve) {
    setTimeout(function() {
      // begin the animation
      element.classList.toggle('DOM-slider-hidden');
      resolve();
    }, +delay > 20 ? +delay : 20);
  }).then(function() {
    return new Promise(function(resolve) {
      setTimeout(function() {
        element.style.removeProperty('max-height');
        element.style.removeProperty('transition');
        element.style.removeProperty('overflow');
        element.removeAttribute('data-sliding');

        styleCache[domSliderId].height = contentHeight;

        resolve(element);
      }, speed);
    });
  });
};
